import { alignItems } from "../../../../../consts";
import { metricsConfig, metricsDescription } from "../../consts/metricsConfig";
import { t } from "../../../../../services";

import { FlexContainers, Paragraph2, WrapperContainer } from "../../../../../components";
import { Circle } from "../LineChartTooltip/styled";
import { MetricsInfoContainer } from "./styled";

const metrics = Object.keys(metricsConfig);

export const MetricsInfoTooltip = () => {
  return (
    <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={8} p={4}>
      {metrics.map((metric) => {
        const config = metricsConfig[metric];
        const description = metricsDescription[metric];

        return (
          <MetricsInfoContainer
            key={metric}
            Container={FlexContainers.FlexRowStart}
            alignItems={alignItems.start}
            gap={8}
            width={"100%"}>
            <Circle background={config?.color} />
            <Paragraph2 dangerouslySetInnerHTML={{ __html: t(description) }} />
          </MetricsInfoContainer>
        );
      })}
    </WrapperContainer>
  );
};
